import { createLogicMiddleware } from "redux-logic";

import {
  autostoreSkuRemovalDisabledLogic,
  fetchShelvesLogic,
  reportMissingItemLogic,
  setMissingSkuFoundLogic,
  forceLiftShelfLogic,
  cancelLiftShelfLogic,
} from "./missingSkuLogic";
import {
  cartScanLogic,
  cartDataLogic,
  fetchCartDataLogic,
  handleSetCartFailureResponseLogic,
} from "./cartLogic";
import { addTimestampOnDispatch, errorLogic, logoutLogic } from "./applicationStateLogic";
import { setInstructionLogic, setWarningModalLogic } from "./instructionLogic";
import {
  boxCallbackLogic,
  sortBoxCallbackLogic,
  switchToDeliveryLogic,
  loadBoxReviewDataLogic,
  fetchIPackImagesLogic,
  fetchShippingMethodsLogic,
  setBoxReviewActionLogic,
} from "./boxReviewLogic";
import { setAFrameReviewBoxLogic, fetchAFrameReviewBoxLogic } from "./aFrameReviewLogic";
import {
  fetchIPackImagesLogic as fetchIPackImagesLogicNew,
  fetchConveyorBoxLogic,
  refreshConveyorBoxLogic,
  updateBoxBarcodeLogic,
  triggerPostPickLogic,
  triggerBatchPickLogic,
  finishSkuPutawayLogic,
  confirmItemRemovaLogic,
  setBoxAsControlledLogic,
  relocateBoxLogic,
  requestNewShippingLabel,
  printNewLabel,
  changeShippingLabelToPosten,
  confirmVerifyPickFinished,
  removeMessageLogic,
} from "./conveyorBoxReviewLogic";

import {
  fetchAutoStoreReviewBoxLogic,
  restartDeliveryAutoStoreBoxLogic,
} from "./autostoreReviewLogic";

import {
  fetchRxBoxLogic,
  pollForRxOrderLogic,
  fetchOrderCommentsLogic,
  pollForRxNextSortBoxLogic,
  cancelSortBoxLogic,
  setRxAssistantOperatorLogic,
  clearRxAssistantOperatorLogic,
  getRxAssistantOperatorLogic,
  fetchWarningMessagesLogic,
  fetchRxSingleItemsLogic,
  fetchRxOperatorInstructionLogic,
  sendScannedIPackBoxbarcodeLogic,
  setOrderInfoLogic,
  fetchFullOrderLogic,
  rxSignalRMessageReceiverLogic,
  sendLoginInfoLogic,
  sendStationPausedLogic,
  sendSortBoxSnoozed,
  sendBoxCancellation,
  setTimeStampLogic,
  sendPrintRXBodIDLogic,
  sendMaxxOrderFinishedLogic,
  getTeamleaderAvailabilityLogic,
  sendFlushQueueRequest,
  setRxBoxLogic,
  performSkuPutawayLogic,
  performSkuPutawayMissingLogic,
  setRxAutoOrderDoneLogic,
  boxNotificationLogic,
  setWarehouseAlarmLogic,
} from "../logic/rxBoxModeLogic";

const missingLogic = [
  autostoreSkuRemovalDisabledLogic,
  fetchShelvesLogic,
  reportMissingItemLogic,
  setMissingSkuFoundLogic,
  forceLiftShelfLogic,
  cancelLiftShelfLogic,
];
const appStateLogic = [errorLogic, logoutLogic, addTimestampOnDispatch];
const cartStateLogic = [
  cartScanLogic,
  cartDataLogic,
  fetchCartDataLogic,
  handleSetCartFailureResponseLogic,
];
const boxReviewLogic = [
  boxCallbackLogic,
  sortBoxCallbackLogic,
  switchToDeliveryLogic,
  loadBoxReviewDataLogic,
  fetchShippingMethodsLogic,
  fetchIPackImagesLogic,
  setBoxReviewActionLogic,
  confirmItemRemovaLogic,
];
const instructionLogic = [setInstructionLogic, setWarningModalLogic];
const aframeReviewBoxLogic = [fetchAFrameReviewBoxLogic, setAFrameReviewBoxLogic];

// notes: Varberg
const conveyorBoxReviewLogic = [
  fetchIPackImagesLogicNew,
  fetchConveyorBoxLogic,
  refreshConveyorBoxLogic,
  updateBoxBarcodeLogic,
  triggerPostPickLogic,
  triggerBatchPickLogic,
  finishSkuPutawayLogic,
  setBoxAsControlledLogic,
  relocateBoxLogic,
  requestNewShippingLabel,
  printNewLabel,
  changeShippingLabelToPosten,
  confirmVerifyPickFinished,
];

const rxBoxModeLogic = [
  sendFlushQueueRequest,
  fetchRxBoxLogic,
  pollForRxOrderLogic,
  fetchOrderCommentsLogic,
  pollForRxNextSortBoxLogic,
  cancelSortBoxLogic,
  setRxAssistantOperatorLogic,
  clearRxAssistantOperatorLogic,
  getRxAssistantOperatorLogic,
  fetchWarningMessagesLogic,
  fetchRxSingleItemsLogic,
  fetchRxOperatorInstructionLogic,
  setOrderInfoLogic,
  sendLoginInfoLogic,
  sendBoxCancellation,
  setRxBoxLogic,
  fetchFullOrderLogic,
  sendScannedIPackBoxbarcodeLogic,
  rxSignalRMessageReceiverLogic,
  sendStationPausedLogic,
  sendSortBoxSnoozed,
  setTimeStampLogic,
  sendPrintRXBodIDLogic,
  sendMaxxOrderFinishedLogic,
  getTeamleaderAvailabilityLogic,
  performSkuPutawayLogic,
  performSkuPutawayMissingLogic,
  setRxAutoOrderDoneLogic,
  boxNotificationLogic,
  setWarehouseAlarmLogic,
];
const autoStoreReviewLogic = [fetchAutoStoreReviewBoxLogic, restartDeliveryAutoStoreBoxLogic];

const logic = [
  ...appStateLogic,
  ...cartStateLogic,
  ...missingLogic,
  ...instructionLogic,
  ...boxReviewLogic,
  ...aframeReviewBoxLogic,
  ...rxBoxModeLogic,
  ...autoStoreReviewLogic,
  ...conveyorBoxReviewLogic,
  removeMessageLogic,
];

const logicMiddleware = createLogicMiddleware(logic, {});

export default logicMiddleware;
